{
  "id": "campaign-062",
  "name": "Busy Hole",
  "seed": "campaign:62",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......www._.",
    "......wooo_.",
    ".......oFo_.",
    ".......ooo_.",
    "...,......_s",
    "..,.,....._s",
    "..T,T..T.T_.",
    "...,,....._.",
    "x..,.....#_.",
    ",........._.",
    ".,..T..T.._.",
    ".........._.",
    "..T.T..T.T_.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 1
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    }
  ],
  "generatorVersion": 3,
  "level": 62,
  "biome": "golf",
  "par": {
    "reel": 6444,
    "push": 5133,
    "selfPropelled": 4950,
    "tractor": 3865,
    "zeroTurn": 3309,
    "fairway": 2082
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 22,
      "selfPropelled": 8,
      "tractor": 18,
      "zeroTurn": 8,
      "fairway": 11
    }
  }
}
